import React from 'react'
import { Switch } from 'element-react'

const SwitchSG = () => {
    return (
        <div>
            {/* Switch ============================  */}
            <Switch value={true} onText="" offText=""></Switch>
            <Switch
                value={true}
                onText=""
                offText=""
                className="secondary"
            ></Switch>
            <Switch
                value={true}
                onText=""
                offText=""
                className="success"
            ></Switch>
            <Switch
                value={true}
                onText=""
                offText=""
                className="warning"
            ></Switch>
            <Switch
                value={true}
                onText=""
                offText=""
                className="danger"
            ></Switch>
            <Switch
                value={true}
                onText="Now we are cooking"
                offText="Oh shoot!"
                width={150}
            ></Switch>
        </div>
    )
}

export default SwitchSG
